import React from 'react';
import './LegalPolicies.css';
import useScrollToTop from './useScrollToTop';

const TermsOfService = () => {
  useScrollToTop();
  return (
    <div className="policy-page">
      <h1>Terms of Service</h1>
      <p>
        Welcome to Housekaar Construction Company. By accessing and using our website (the "Site") and our services (the "Services"), you agree to be bound by these Terms of Service ("Terms"). Please read them carefully. If you do not agree to these Terms, you should not use our Site or Services.
      </p>

      <section>
        <h2>1. Acceptance of Terms</h2>
        <p>
          These Terms constitute a legally binding agreement between you and Housekaar Construction Company ("Housekaar," "we," "us," or "our"). By using our Site or Services, you acknowledge that you have read, understood, and agree to be bound by these Terms, including any additional guidelines and future modifications.
        </p>
      </section>

      <section>
        <h2>2. Use of Our Site and Services</h2>
        <p>
          Our Site and Services are primarily intended to provide information about our construction services in Patna, Bihar, and to facilitate communication with potential clients. You may use our Site and Services for lawful purposes only. You agree not to:
        </p>
        <ul>
          <li>Provide false or misleading information.</li>
          <li>Interfere with the operation of our Site or Services.</li>
          <li>Attempt to gain unauthorized access to any part of our Site or Services.</li>
          <li>Use our Site or Services in any way that violates applicable laws or regulations in Patna, Bihar, or India.</li>
          <li>Collect or store personal data of other users without their express consent.</li>
        </ul>
      </section>

      <section>
        <h2>3. User Responsibilities</h2>
        <p>
          You are responsible for maintaining the confidentiality of any login credentials you may be provided to access certain features of our Site or Services. You are also responsible for all activities that occur under your account. You agree to notify us immediately of any unauthorized use of your account.
        </p>
      </section>

      <section>
        <h2>4. Intellectual Property Rights</h2>
        <p>
          All content on this Site, including but not limited to text, graphics, logos, images, videos, and software, is the property of Housekaar Construction Company or its licensors and is protected by copyright, trademark, and other intellectual property laws in India and internationally. You may not reproduce, distribute, modify, display, perform, or otherwise use any of our content without our prior written consent.
        </p>
      </section>

      <section>
        <h2>5. Disclaimer of Warranties</h2>
        <p>
          Our Site and Services are provided on an "as is" and "as available" basis without any warranties of any kind, express or implied, including but not limited to warranties of merchantability, fitness for a particular purpose, and non-infringement. We do not warrant that our Site or Services will be uninterrupted, error-free, or secure.
        </p>
      </section>

      <section>
        <h2>6. Limitations of Liability</h2>
        <p>
          To the maximum extent permitted by applicable law, Housekaar Construction Company shall not be liable for any indirect, incidental, special, consequential, or punitive damages (including, without limitation, damages for loss of profits, data, use, goodwill, or other intangible losses) arising out of or relating to your use of or inability to use our Site or Services, even if we have been advised of the possibility of such damages. Our total liability to you for all claims arising out of or relating to these Terms or your use of our Site or Services shall not exceed the amount, if any, paid by you to us for the Services in the twelve (12) months preceding the event giving rise to the liability.
        </p>
      </section>

      <section>
        <h2>7. Payment Terms (If Applicable)</h2>
        <p>
          If our Services involve any fees, the specific payment terms will be outlined in a separate agreement or on the relevant section of our Site. You agree to pay all fees in accordance with the agreed-upon terms.
        </p>
      </section>

      <section>
        <h2>8. Third-Party Links</h2>
        <p>
          Our Site may contain links to third-party websites or services that are not owned or controlled by Housekaar Construction Company. We have no control over and assume no responsibility for the content, privacy policies, or practices of any third-party websites or services. You acknowledge and agree that Housekaar shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with the use of or reliance on any such content, goods, or services available on or through any such third-party websites or services.
        </p>
      </section>

      <section>
        <h2>9. Governing Law and Dispute Resolution</h2>
        <p>
          These Terms shall be governed by and construed in accordance with the laws of India, without regard to its conflict of law provisions. Any legal action or proceeding arising out of or relating to these Terms or your use of our Site or Services shall be brought exclusively in the courts located in Patna, Bihar, and you hereby consent to the personal jurisdiction of such courts.
        </p>
      </section>

      <section>
        <h2>10. Termination</h2>
        <p>
          We reserve the right to terminate or suspend your access to our Site and Services, without prior notice or liability, for any reason whatsoever, including without limitation if you breach these Terms. Upon termination, your right to use the Site and Services will immediately cease.
        </p>
      </section>

      <section>
        <h2>11. Modifications to These Terms</h2>
        <p>
          We reserve the right to modify or update these Terms at any time without prior notice. Any changes will be effective immediately upon posting on this Site. Your continued use of our Site or Services after any such changes constitutes your acceptance of the new Terms. It is your responsibility to review these Terms periodically for updates.
        </p>
      </section>

      <section>
        <h2>12. Contact Us</h2>
        <p>
          If you have any questions about these Terms of Service, please contact us at:
           help@housekaar.com
           8828531570
           Housekaar Patna, Bihar
        </p>
      </section>
    </div>
  );
};

export default TermsOfService;